import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { breakpoints } from './../../constants/breakpoits.constants'
import { connect } from 'react-redux'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { bindActionCreators } from 'redux'
import Modal from '../modal/modal.component'
import { WHITE, MEDIUMORANGE, BLUE } from '../../styles/colors.style'
import { MuvicardService } from '../../services/muvicard.service'
import { toastActions } from '../../actions'

const StyledSpan = styled.span`
	a {
		min-width: 7.5rem;
		flex-direction: column;
		@media (min-width: ${breakpoints.MOBILE}px) {
			font-size: 1.5rem !important;
		}

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			min-width: 80px;
		}
	}

	div {
		@media (min-width: ${breakpoints.MOBILE}px) {
			min-width: 65px;
			width: min-content;
		}
	}
`

const BoxModal = styled.div`
	background: ${WHITE};
	padding: 60px 40px 0 40px;

	h3 {
		font-size: 1.8rem;
		@media (min-width: ${breakpoints.MOBILE}px) {
			font-size: 2.5rem;
		}
	}

	footer {
		padding: 40px 0;
		display: flex;
		justify-content: flex-end;

		button {
			border: 0;
			margin: 0 10px;
			background: ${BLUE};
			color: #ffffff;
			font: 600 2.5rem/25px 'Source Sans Pro';
			cursor: pointer;
			padding: 0 16px;
			height: 45px;
			border-radius: 5px;

			&:last-child {
				margin-right: 0;
				background: ${MEDIUMORANGE};
			}
		}
	}
`
class MenuItem extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: false,
			status: 'bloquear',
			canUpdateStatus: true,
		}
	}

	send = () => {
		const { showLoading, hideLoading, toastSuccess, toastError } = this.props

		MuvicardService.GetCardInfo().then((res) => {
			showLoading()
			if (res.success) {
				if (res.data.status === 'Ativo') {
					toastSuccess({
						message: 'Cartão bloqueado com sucesso.',
					})
					MuvicardService.CardBlock()
					this.setState({ status: 'desbloquear' })
				} else if (res.data.status === 'Bloqueado') {
					toastSuccess({
						message: 'Cartão desbloqueado com sucesso.',
					})
					MuvicardService.CardUnblock()
					this.setState({ status: 'bloquear' })
				} else {
					toastSuccess({
						message: 'Não foi possível desbloquear este cartão.',
					})
				}
				this.closeModal()
			} else {
				if (res.errors && res.errors.length > 0) {
					toastError({ message: res.errors })
				}
			}
			hideLoading()
		})
	}

	closeModal = () => {
		this.setState({ isOpen: false })
	}

	getCardInfo = () => {
		const { showLoading, hideLoading, toastError } = this.props

		MuvicardService.GetCardInfo().then((res) => {
			showLoading()

			if (res.success) {
				if (res.data.status === 'Ativo') {
					this.setState({ status: 'bloquear', canUpdateStatus: true })
				} else if (res.data.status === 'Bloqueado') {
					this.setState({
						status: 'desbloquear',
						canUpdateStatus: true,
					})
				} else {
					this.setState({
						status: 'bloquear',
						canUpdateStatus: false,
					})
				}
			} else {
				if (res.errors && res.errors.length > 0) {
					toastError({ message: res.errors })
				}
			}
			hideLoading()
		})
	}
	render() {
		const { menuOptionPath, closeMobileMenu } = this.props
		return (
			<React.Fragment>
				<StyledSpan>
					{this.props.renderUrl ? (
						<a href={this.props.route} target="_blank">
							<div>
								<svg
									width="30px"
									height="30px"
									viewBox={
										this.props.viewBox
											? this.props.viewBox
											: '0 0 576 512'
									}
									xmlns="http://www.w3.org/2000/svg">
									<path d={this.props.iconItem} />
								</svg>
								<div>{this.props.label}</div>
							</div>
						</a>
					) : (
						<Link to={this.props.route}>
							<div
								onClick={(e) => {
									if (
										this.props.label == 'Bloquear/ Desbloquear cartão'
									) {
										e.preventDefault()
										this.getCardInfo()
										this.setState({ isOpen: true })
									}
									closeMobileMenu()
									menuOptionPath(this.props.route)
								}}>
								<svg
									width="35px"
									height="30px"
									viewBox={
										this.props.viewBox
											? this.props.viewBox
											: '50 -110 1792 1792'
									}
									xmlns="http://www.w3.org/2000/svg">
									<path d={this.props.iconItem} />
								</svg>
								<div>{this.props.label}</div>
							</div>
						</Link>
					)}
				</StyledSpan>
				<Modal
					noPadding
					animation="fadeIn"
					isOpen={this.state.isOpen}
					onClose={() => this.closeModal()}>
					<BoxModal>
						{this.state.canUpdateStatus ? (
							<div>
								<h3>
									Deseja realmente {this.state.status} o seu cartão?
								</h3>

								<footer>
									<button onClick={() => this.closeModal()}>
										Cancelar
									</button>
									<button
										onClick={() => this.send()}
										disabled={!this.state.canUpdateStatus}>
										Confirmar
									</button>
								</footer>
							</div>
						) : (
							<div>
								<h3>Cartão inválido para bloqueio e desbloqueio</h3>
								<footer>
									<button onClick={() => this.closeModal()}>
										Fechar
									</button>
								</footer>
							</div>
						)}
					</BoxModal>
				</Modal>
			</React.Fragment>
		)
	}
}

const mapStateToProps = ({ site }) => ({
	menuOptionPath: site.menuOptionPath,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			menuOptionPath: SiteCreators.menuOptionPath,
			closeMobileMenu: SiteCreators.closeMobileMenu,
			closePrivateMenu: SiteCreators.closePrivateMenu,
			showLoading: SiteCreators.showLoading,
			hideLoading: SiteCreators.hideLoading,
			toastSuccess: toastActions.success,
			toastError: toastActions.danger,
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(MenuItem)
